import { Link } from 'react-router-dom';

import { ReactComponent as Hide } from './../../../../assets/svg/hide.svg';
import styles from './WalletHeader.module.css';

export const WalletHeader = ({ closePopup }) => (
  <div className={styles.WalletHeader}>
    <button className={styles.HideBtn} onClick={() => closePopup(false)} type="button">
      <Hide />
    </button>
    <Link className={styles.TransactionsBtn} to="/credit/">
      {' '}
      تراکنش ها
    </Link>
  </div>
);
